module.exports = __webpack_public_path__ + "static/media/icon-address.4d1bbc2d.svg";